'use strict';

module.exports = {
  INFO: 'INFO',
  WARN: 'WARNING',
  ERROR: 'ERROR',
  LOG: 'LOG',
  VERBOSE: 'VERBOSE'
};
